import { Box, Typography, Tab, Tabs, Button, TextField, Grid, Stack, TableContainer, Table, Paper, TableBody, TableRow, TableCell } from "@mui/material";
import React, { useState } from "react";
import { useTheme } from '@mui/material/styles';
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';
import PropTypes from 'prop-types';
import ApiService from "../api_service/api_service";
import {priceSplitor} from "../core/price_splitor";
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import CameraIcon from '@mui/icons-material/Camera';
import MemoryIcon from '@mui/icons-material/Memory';
import BatteryChargingFullIcon from '@mui/icons-material/BatteryChargingFull';
import SearchIcon from '@mui/icons-material/Search';
import HTMLRenderer from 'react-html-renderer'
import IPhone from '../assets/images/apple-iphone-12-mini.jpg'

import ColoredCircle from "../components/ColoredCircle";
import theme from "../utils/theme";
import CompareWith from "../components/CompareWith";
import RelatedPhones from "../components/product_detail_components/RelatedPhones";

import KBZPay from "../assets/images/kbz-pay.png";
import WavePay from "../assets/images/wave-pay.png";
import AyaPay from "../assets/images/aya-pay.png";
import CBPay from "../assets/images/cb-pay.png";
import ABank from "../assets/images/a-bank.png";

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const ProductDetail = () => {
    var [isSearch, setIsSearch] = useState(false);
    var [name, setName] = useState('');
    var [images, setImages] = useState([]);

    const id = new URLSearchParams(document.location.search);
    // const search = document.location.search;
    const pId = id.get('id');

    const [product, setProduct] = useState({});
    const [phones, setPhones] = useState([]);

    const getProduct = async () => {
        let response = await ApiService.productById(id);
        setProduct(response.data);
        setImages(response.data.images);
        console.log(response.data);
         let pdt = response.data;
        let phList = [];
     //    console.log(`ID is ${id}`);
     //    console.log(pdt.variations);
        for(var i = 0; i < pdt.variations.length; i++){
             phList.push({
                 id: pdt.variations[i]._id,
                 imgPath: ApiService.basedPublicURL + pdt.variations[i].photo,
                 color: pdt.variations[i].color,
                 colorName: pdt.variations[i].name,
                 isSelected: i == 0 ? true : false
             });
        }
        setPhones(phList);
    };

    React.useEffect(() => {
        getProduct();
    }, [pId]);


    const handleSelectColor = (selectedColor) => {
        const updatedPhones = phones.map(phone => ({
            ...phone,
            isSelected: phone.color === selectedColor,
        }));

        setPhones(updatedPhones);
    }

    const selectedPhone = phones.length == 0 ? 
    {
        id: '1',
        imgPath: IPhone,
        color: '#ff0000',
        colorName: 'Red',
        isSelected: true,
    }
    : phones.find(phone => phone.isSelected);

    const theme = useTheme();
    const [activeStep, setActiveStep] = React.useState(0);

    const handleStepChange = (step) => {
        setActiveStep(step);
    };

    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    
    const handleChangeIndex = (index) => {
        setValue(index);
    };

    return (
        <Box sx={{
            px: { xs: '50px' },
            pb: '70px',
            pt: '30px'
        }}>
            <Box sx={{ display: {md: 'flex'}, gap: '37px' }}>
                <Box sx={{ width: {md: '70%'}, display: 'flex', flexDirection: {xs:'column', sm:'row'}, gap: '10px' }}>
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: {xs: '100%', sm: '50%', md:'300px'},
                        height: 'auto'
                    }}>
                        <img
                            alt='Header Icon'
                            loading="lazy"
                            src={ selectedPhone.imgPath }
                            style={{width: '100%', height: 'auto' }}
                        />
                    </Box>
                    <Typography sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                        <Box sx={{ fontSize: "20px", fontWeight: 500 }} >{product.brand?.name}  {product.name}</Box>
                        <Box sx={{ fontSize: "14px" }} >{product.description}</Box>
                        <Box sx={{ fontSize: "24px", fontWeight: 500, color: '#EC1D25' }} >{product.price?.toLocaleString()} KS</Box>
                        <Box sx={{ fontSize: "16px", fontWeight: 500, color: '#3A3A3C' }} >Storage - {product.specifications?.filter(sp => sp.name == 'ROM')[0]?.value}</Box>
                    

                        <Box sx={{ fontSize: "16px", fontWeight: 500, color: '#3A3A3C', display: 'flex', alignItems: 'center', gap: '10px' }} >Colour - 
                            <Box sx={{
                                display: 'flex',
                                alignItems: 'center',
                            }}>
                                {phones.map((phone, index) => (
                                    <ColoredCircle
                                        key={index}
                                        color={phone.color}
                                        isSelected={phone.isSelected}
                                        onClick={() => handleSelectColor(phone.color)}
                                    />
                                ))}
                            </Box>
                        </Box>
                    </Typography>
                </Box>
                <Box sx={{ width: {md: '30%'} }}>
                    <Typography>
                        <Box sx={{ fontSize: "20px", fontWeight: 500 }}>Delivery</Box>
                        <Box sx={{ fontSize: "14px" }}>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since 1966, when designers at Letraset and James Mosley, the librarian at St Bride Printing Library in London, took a 1914.</Box>
                        <Box sx={{ fontSize: "20px", fontWeight: 500, marginTop: "24px" }}>Payment we accept</Box>
                    </Typography>
                    <Box sx={{ display: 'flex', gap: '8px', mt: '2px' }}>
                        <img src={KBZPay} width="40px" height="40px" />
                        <img src={AyaPay} width="40px" height="40px" />
                        <img src={WavePay} width="40px" height="40px" />
                        <img src={ABank} width="40px" height="40px" />
                        <img src={CBPay} width="40px" height="40px" />
                    </Box>
                </Box>
            </Box>
            <Box sx={{ marginTop: '58px' }}>
                {
                    product.category != null ? 
                    (product.category._id == "65cb5c641e133cb8436e4dd4" || product.category._id == "65cc477482513024d3c7f231" || product.category._id == "65cc477a82513024d3c7f236" )
                    ? (
                        <Box sx={{
                            width: { md : '60%' }
                        }}>
                            <Tabs value={value} onChange={handleChange} aria-label="disabled tabs example" >
                                <Tab label="Main Features" sx={{ fontSize: theme.palette.Content.fontSize, textTransform: 'none', bgcolor: value == 0 ? '#FFD4D8' : '#F4F5F8', fontWeight: value == 0 ? 600 : 400 }} />
                                <Tab label="Specification" sx={{ fontSize: theme.palette.Content.fontSize, textTransform: 'none', bgcolor: value == 1 ? '#FFD4D8' : '#F4F5F8', fontWeight: value == 1 ? 600 : 400 }} />
                            </Tabs>
                            <Box sx={{ height: "35px" }}></Box>
                            <SwipeableViews
                                axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                                index={value}
                                onChangeIndex={handleChangeIndex}
                            >
                                <TabPanel value={value} index={0} dir={theme.direction}>
                                    <MainFeature props={{ product }} />
                                </TabPanel>
                                <TabPanel value={value} index={1} dir={theme.direction}>
                                    <Specification props={{ product }}/>
                                </TabPanel>
                            </SwipeableViews>
                        </Box>
                    )
                    : (<Box></Box>)
                    : (<Box></Box>)
                }
            </Box>


            {
                product && product._id &&
                <Box>
                    <Typography sx={{ mb: '24px', mt: '58px' }}>
                        <Box sx={{ fontSize: '24px', color: '#3A3A3C', fontWeight: 500 }}>Related Products</Box>
                    </Typography>
                    <RelatedPhones props={{ offset: 0, categoryId: product.category?._id, brandId: product.brand?._id, product, }}/>
                </Box>
            }

            
        </Box>
    )
}

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

const MainFeature = (props) => {
    const product = props.props.product;
    const specs = product.specifications;
    var cpu;
    var ram;
    var screenSize;
    var resolution;
    var battery;
    var mainCamera;
    var selfieCamera;
    specs.forEach((spec) => {

        //Mac, Mobile Phone, Tablet
        // if(spec.specificationId == "65f2d05f1f22b18c241b228a" || spec.specificationId == "65f2b74b1f22b18c241a6f06" || spec.specificationId == "65f2c8a41f22b18c241b0adc"){
        //     cpu = spec.value;
        // }
        // if(spec.specificationId == "65f2d05f1f22b18c241b228b" || spec.specificationId == "65f2b74b1f22b18c241a6f07" || spec.specificationId == "65f2c8a41f22b18c241b0add"){
        //     ram = spec.value;
        // }
        // if(spec.specificationId == "65f2d05f1f22b18c241b228d" || spec.specificationId == "65f2b74b1f22b18c241a6f09" || spec.specificationId == "65f2c8a41f22b18c241b0adf"){
        //     battery = spec.value;
        // }
        // if(spec.specificationId == "65f2d05f1f22b18c241b228e" || spec.specificationId == "65f2b74b1f22b18c241a6f0a" || spec.specificationId == "65f2c8a41f22b18c241b0ae0"){
        //     mainCamera = spec.value;
        // }
        // if(spec.specificationId == "65f2d05f1f22b18c241b228f" || spec.specificationId == "65f2b74b1f22b18c241a6f0b" || spec.specificationId == "65f2c8a41f22b18c241b0ae1"){
        //     selfieCamera = spec.value;
        // }
        // if(spec.specificationId == "65f2d05f1f22b18c241b2292" || spec.specificationId == "65f2b74b1f22b18c241a6f0e" || spec.specificationId == "65f2c8a41f22b18c241b0ae4"){
        //     screenSize = spec.value;
        // }
        // if(spec.specificationId == "65f2d05f1f22b18c241b2293" || spec.specificationId == "65f2b74b1f22b18c241a6f0f" || spec.specificationId == "65f2c8a41f22b18c241b0ae5"){
        //     resolution = spec.value;
        // }

        if(spec.name == "Chipset"){
            cpu = spec.value;
        }
        if(spec.name == "RAM"){
            ram = spec.value;
        }
        if(spec.name == "Battery"){
            battery = spec.value;
        }
        if(spec.name == "Main Camera"){
            mainCamera = spec.value;
        }
        if(spec.name == "Selfie Camera"){
            if(spec.value != "-"){
                selfieCamera = spec.value;
            }
        }
        if(spec.name == "Screen Size"){
            screenSize = spec.value;
        }
        if(spec.name == "Display Resolution"){
            resolution = spec.value;
        }
        
    });
    return (
        <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2} columns={{ xs: 1, sm: 2 }}>
                <Grid item xs={1} >
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: { md: 'start' },
                            alignItems: 'center',
                            p: '8px',
                            bgcolor: 'rgba(128, 128, 128, 0.2)',
                        }}
                    >
                        <PhoneIphoneIcon sx={{ fontSize: '70px', color: '#3A3A3C' }} />
                        <Box>
                            <Typography sx={{ fontSize: theme.palette.Content.SmallFont }}>
                                Screen Size
                            </Typography>
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ width: '5px', height: '5px', borderRadius: '50%', bgcolor: 'black', m: '15px' }} />
                                <Typography sx={{ fontSize: theme.palette.Content.SmallFont }}>{screenSize}</Typography>
                            </Box>
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ width: '5px', height: '5px', borderRadius: '50%', bgcolor: 'black', m: '15px' }} />
                                <Typography sx={{ fontSize: theme.palette.Content.SmallFont }}>{resolution}</Typography>
                            </Box>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={1} >
                    <Box sx={{
                        display: 'flex',
                        justifyContent: { md: 'start' },
                        alignItems: 'center',
                        p: '8px',
                        bgcolor: 'rgba(128, 128, 128, 0.2)',
                       
                    }}>
                        <CameraIcon sx={{ fontSize: '70px', color: '#3A3A3C' }} />
                        <Box>
                            <Typography sx={{
                                fontSize: theme.palette.Content.SmallFont
                            }}>Camera</Typography>
                            <Box sx={{
                                display: 'flex',
                                alignItems: 'center'
                            }}>
                                <Box sx={{
                                    width: '5px',
                                    height: '5px',
                                    borderRadius: '50%',
                                    bgcolor: 'black',
                                    m: '15px'
                                }} />
                                <Typography sx={{
                                    fontSize: theme.palette.Content.SmallFont
                                }}>{mainCamera}</Typography>
                            </Box>
                            <Box sx={{
                                display: 'flex',
                                alignItems: 'center'
                            }}>
                                <Box sx={{
                                    width: '5px',
                                    height: '5px',
                                    borderRadius: '50%',
                                    bgcolor: 'black',
                                    m: '15px'
                                }} />
                                <Typography sx={{
                                    fontSize: theme.palette.Content.SmallFont
                                }}>{selfieCamera}</Typography>
                            </Box>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={1} >
                    <Box sx={{
                        display: 'flex',
                        justifyContent: { md: 'start' },
                        alignItems: 'center',
                        p: '8px',
                        bgcolor: 'rgba(128, 128, 128, 0.2)',
                    }}>
                        <MemoryIcon sx={{ fontSize: '70px', color: '#3A3A3C' }} />
                        <Box>
                            <Typography sx={{
                                fontSize: theme.palette.Content.SmallFont
                            }}>RAM | CPU</Typography>
                            <Box sx={{
                                display: 'flex',
                                alignItems: 'center'
                            }}>
                                <Box sx={{
                                    width: '5px',
                                    height: '5px',
                                    borderRadius: '50%',
                                    bgcolor: 'black',
                                    m: '15px'
                                }} />
                                <Typography sx={{
                                    fontSize: theme.palette.Content.SmallFont
                                }}>{ram}</Typography>
                            </Box>
                            <Box sx={{
                                display: 'flex',
                                alignItems: 'center'
                            }}>
                                <Box sx={{
                                    width: '5px',
                                    height: '5px',
                                    borderRadius: '50%',
                                    bgcolor: 'black',
                                    m: '15px'
                                }} />
                                <Typography sx={{
                                    fontSize: theme.palette.Content.SmallFont
                                }}>{cpu}</Typography>
                            </Box>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={1} >
                    <Box sx={{
                        display: 'flex',
                        justifyContent: { md: 'start' },
                        alignItems: 'center',
                        p: '8px',
                        bgcolor: 'rgba(128, 128, 128, 0.2)',
                    }}>
                        <BatteryChargingFullIcon sx={{ fontSize: '70px', color: '#3A3A3C' }} />
                        <Box>
                            <Typography sx={{
                                fontSize: theme.palette.Content.SmallFont
                            }}>Battery</Typography>
                            <Box sx={{
                                display: 'flex',
                                alignItems: 'center'
                            }}>
                                <Box sx={{
                                    width: '5px',
                                    height: '5px',
                                    borderRadius: '50%',
                                    bgcolor: 'black',
                                    m: '15px'
                                }} />
                                <Typography sx={{
                                    fontSize: theme.palette.Content.SmallFont
                                }}>{battery}</Typography>
                            </Box>
                            <Box sx={{
                                display: 'flex',
                                alignItems: 'center'
                            }}>
                                <Box sx={{
                                    width: '5px',
                                    height: '5px',
                                    borderRadius: '50%',
                                    bgcolor: 'rgba(128, 128, 128, 0.2)',
                                    m: '15px'
                                }} />
                            </Box>
                        </Box>
                    </Box>
                </Grid>
            </Grid>

        </Box>
    )
}

const Specification = (props) => {
    const product = props.props.product;
    const specs = product.specifications;
    return (
        <TableContainer
            component={Paper}
            elevation={0}
            sx={{
                borderRadius: 0,
            }}
        >
            <Table>
                <TableBody>
                {specs.map((row, index) => (
                    <TableRow
                    key={index}
                    sx={{
                        // တစ်ကြောင်းခြား စီ နောက်ခံအရောင် မီးခိုးဖျော့ ပြောင်းရန်
                        backgroundColor: index % 2 === 1 ? '#FBF9F9' : '#ffffff',
                        '&:last-child td, &:last-child th': { border: 0 },
                    }}
                    >
                    {/* Label Column (Left Side) */}
                    <TableCell
                        component="th"
                        scope="row"
                        sx={{
                        fontWeight: 500,
                        fontSize: '14px',
                        color: '#3A3A3C',
                        width: '30%',
                        verticalAlign: 'top',
                        padding: '16px 24px',
                        borderBottom: 'none',
                        }}
                    >
                        {row.name}
                    </TableCell>

                    {/* Value Column (Right Side) */}
                    <TableCell
                        align="left"
                        sx={{
                        fontSize: '14px',
                        color: '#3A3A3C',
                        verticalAlign: 'top',
                        padding: '16px 24px',
                        borderBottom: 'none',
                        lineHeight: 1.6,
                        }}
                    >
                        {row.value}
                    </TableCell>
                    </TableRow>
                ))}
                </TableBody>
            </Table>
        </TableContainer>
    )
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

export default ProductDetail